import { useState } from "react";
import { useTranslation } from "react-i18next";

import { authHeaders } from "@/api/school";

import { openAuthedPdf } from "./PrintoutsPanel";

/** 图文版试卷(HTML)— Jarod 2026-08-11:数理化的电路图/几何图在纯
 *  文字 PDF 里出不来,改由 AI 生成自包含 HTML(插图内联 SVG),浏览器
 *  里打印/存 PDF。生成走 LLM,约 1-2 分钟,期间按钮转圈。 */
export function HtmlPaperPanel({ examId }: { examId: string }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [lastUrl, setLastUrl] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function generate() {
    setBusy(true);
    setErr(null);
    try {
      const r = await fetch(`/api/school/exams/${examId}/paper/html`, {
        method: "POST",
        headers: authHeaders(),
      });
      const body = (await r.json().catch(() => ({}))) as { download?: string; detail?: string };
      if (!r.ok || !body.download) throw new Error(body.detail ?? `HTTP ${r.status}`);
      setLastUrl(body.download);
      await openAuthedPdf(body.download);
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mt-4 rounded-lg border border-slate-200 bg-white p-4">
      <h3 className="text-sm font-semibold text-slate-700 mb-1">{t("htmlPaper.title")}</h3>
      <p className="text-xs text-slate-500 mb-2.5">{t("htmlPaper.hint")}</p>
      <div className="flex items-center gap-3">
        <button
          type="button"
          disabled={busy}
          onClick={() => void generate()}
          className="px-4 py-2 text-sm font-medium rounded bg-sky-500 text-white hover:bg-sky-600 disabled:opacity-50"
        >
          {busy ? t("htmlPaper.generating") : t("htmlPaper.generate")}
        </button>
        {lastUrl && !busy && (
          <button
            type="button"
            onClick={() => void openAuthedPdf(lastUrl)}
            className="text-xs text-sky-600 hover:underline"
          >
            {t("htmlPaper.reopen")}
          </button>
        )}
      </div>
      {err && <p className="mt-2 text-xs text-rose-500">{err}</p>}
    </div>
  );
}
